import { useEffect } from "react";

import {
  configureFtdTelemetry,
  type FtdTelemetryConfig,
} from "./ftd-telemetry";

/**
 * Подключает отправку событий FTD-воронки (см. ftd-telemetry.ts). Ставится
 * в root рядом с WebVitalsReporter, конфигурирует клиент один раз на
 * документ; события, отправленные раньше (клик до гидрации), уходят из
 * очереди сразу после этого.
 */
export const FtdTelemetryInit = (props: FtdTelemetryConfig): null => {
  const {
    collectorProxyUrl,
    siteEnvironment,
    siteBrand,
    skipReporting,
    isLoggedIn,
    playerId,
  } = props;

  useEffect(() => {
    try {
      configureFtdTelemetry({
        collectorProxyUrl,
        siteEnvironment,
        siteBrand,
        skipReporting,
        isLoggedIn,
        playerId,
      });
    } catch {
      // Наблюдаемость не имеет права ломать страницу.
    }
  }, [
    collectorProxyUrl,
    siteEnvironment,
    siteBrand,
    skipReporting,
    isLoggedIn,
    playerId,
  ]);

  return null;
};
